import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { GenericResponse } from '@app/core/models/generic-response';
import { DocType } from '@app/core/models/doc-type.model';
import { TenantStateService } from './tenant-state.service';

export interface NewUploadSessionDto {
    user: string;
    clientId: string;
    createDate: string; // ISO string
    note: string;
    status: string;
    userTimeZoneIana?: string;
    tenantTimeZoneIana?: string;
    tenantId?: string;
    offsetMinutesAtUpload?: number;
}

export interface UploadSessionDto {
    sessionId: string;
    user: string;
    clientId: string;
    createDate: string;
    createDateUtc: string;
    displayCreateDate?: string;
    note: string;
    status: string;
    fileName?: string;
    totalFiles?: number;
    docType?: DocType;
    completeDate?: string | null;
    completeDateUtc?: string | null;
    userName?: string;
    userTimeZoneIana?: string;
    offsetMinutesAtUpload?: number;
}

@Injectable({
    providedIn: 'root',
})
export class UploadSessionService {
    constructor(
        private http: HttpClient,
        private tenantStateService: TenantStateService
    ) {}

    createNewSession(uploadSession: NewUploadSessionDto): Observable<GenericResponse<UploadSessionDto>> {
        const url = `${environment.apiRoot}sessions`;
        const tenantGuid =
            uploadSession.tenantId && uploadSession.tenantId.length > 0
                ? uploadSession.tenantId
                : this.tenantStateService.getCurrentTenantId();

        if (!tenantGuid) {
            return throwError(() => new Error('Tenant ID is required to create a new session.'));
        }

        const headers = new HttpHeaders({
            'X-ClientId': uploadSession.clientId,
            'X-User': uploadSession.user,
            'X-Tenant-Id': tenantGuid,
            'Content-Type': 'application/json',
        });

        const payload = {
            ...uploadSession,
            tenantId: tenantGuid,
        };

        return this.http.post<GenericResponse<UploadSessionDto>>(url, payload, { headers }).pipe(
            // tap((response) => console.debug('API Response:', response)),
            catchError((error: HttpErrorResponse) => {
                // console.error('Error creating new session:', error);
                return throwError(() => new Error('Error creating new session'));
            })
        );
    }
}
